import {
  CREATE_CATEGORY,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  PARENT_CATEGORY_LIST,
  PARENT_CATEGORY_LIST_SUCCESS,
  PARENT_CATEGORY_LIST_FAILURE,
  SUB_CATEGORY_LIST,
  SUB_CATEGORY_LIST_SUCCESS,
  SUB_CATEGORY_LIST_FAILURE,
  CHILD_CATEGORY_LIST,
  CHILD_CATEGORY_LIST_SUCCESS,
  CHILD_CATEGORY_LIST_FAILURE,
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILURE,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  VIEW_CATEGORY,
  VIEW_CATEGORY_SUCCESS,
  VIEW_CATEGORY_FAILURE,
  UPDATE_STATUS_CATEGORY,
  UPDATE_STATUS_CATEGORY_SUCCESS,
  UPDATE_STATUS_CATEGORY_FAILURE,
  GET_PARENT_SUB_CATEGORY_PRODUCT,
  GET_PARENT_SUB_CATEGORY_PRODUCT_SUCCESS,
  GET_PARENT_SUB_CATEGORY_PRODUCT_FAILURE,
  PARENT_CATEGORY_BY_CHILD,
  PARENT_CATEGORY_BY_CHILD_SUCCESS,
  PARENT_CATEGORY_BY_CHILD_FAILURE
} from "../types";

export const createCategory = (payload) => ({
  type: CREATE_CATEGORY,
  payload,
});

export const createCategorySuccess = (payload) => ({
  type: CREATE_CATEGORY_SUCCESS,
  payload,
});

export const createCategoryFailure = (payload) => ({
  type: CREATE_CATEGORY_FAILURE,
  payload,
});

export const getParentCategory = (payload) => ({
  type: PARENT_CATEGORY_LIST,
  payload,
});

export const getParentCategorySuccess = (payload) => ({
  type: PARENT_CATEGORY_LIST_SUCCESS,
  payload,
});

export const getParentCategoryFailure = (payload) => ({
  type: PARENT_CATEGORY_LIST_FAILURE,
  payload,
});

export const getSubCategory = (payload) => ({
  type: SUB_CATEGORY_LIST,
  payload,
});

export const getSubCategorySuccess = (payload) => ({
  type: SUB_CATEGORY_LIST_SUCCESS,
  payload,
});

export const getSubCategoryFailure = (payload) => ({
  type: SUB_CATEGORY_LIST_FAILURE,
  payload,
});

export const getParentCategoryByChild = (payload) => ({
  type: PARENT_CATEGORY_BY_CHILD,
  payload,
});

export const getParentCategoryByChildSuccess = (payload) => ({
  type: PARENT_CATEGORY_BY_CHILD_SUCCESS,
  payload,
});

export const getParentCategoryByChildFailure = (payload) => ({
  type: PARENT_CATEGORY_BY_CHILD_FAILURE,
  payload,
});

export const getChildCategoryList = (payload) => ({
  type: CHILD_CATEGORY_LIST,
  payload,
});

export const getChildCategoryListSuccess = (payload) => ({
  type: CHILD_CATEGORY_LIST_SUCCESS,
  payload,
});

export const getChildCategoryListFailure = (payload) => ({
  type: CHILD_CATEGORY_LIST_FAILURE,
  payload,
});


export const getCategoryList = (payload) => ({
  type: GET_CATEGORY_LIST,
  payload,
});

export const getCategoryListSuccess = (payload) => ({
  type: GET_CATEGORY_LIST_SUCCESS,
  payload,
});

export const getCategoryListFailure = (payload) => ({
  type: GET_CATEGORY_LIST_FAILURE,
  payload,
});


export const updateCategory = (payload) => ({
  type: UPDATE_CATEGORY,
  payload,
});

export const updateCategorySuccess = (payload) => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload,
});

export const updateCategoryFailure = (payload) => ({
  type: UPDATE_CATEGORY_FAILURE,
  payload,
});

export const updateStatusCategory = (payload) => ({
  type: UPDATE_STATUS_CATEGORY,
  payload,
});

export const updateStatusCategorySuccess = (payload) => ({
  type: UPDATE_STATUS_CATEGORY_SUCCESS,
  payload,
});

export const updateStatusCategoryFailure = (payload) => ({
  type: UPDATE_STATUS_CATEGORY_FAILURE,
  payload,
});

export const viewCategory = (payload) => ({
  type: VIEW_CATEGORY,
  payload,
});

export const viewCategorySuccess = (payload) => ({
  type: VIEW_CATEGORY_SUCCESS,
  payload,
});

export const viewCategoryFailure = (payload) => ({
  type: VIEW_CATEGORY_FAILURE,
  payload,
});

// GET category by product

export const subcategoryproducts = (payload) => ({
  type: GET_PARENT_SUB_CATEGORY_PRODUCT,
  payload,
});

export const subcategoryproductssuccess = (payload) => ({
  type: GET_PARENT_SUB_CATEGORY_PRODUCT_SUCCESS,
  payload,
});

export const subcategoryproductsfailure = (payload) => ({
  type: GET_PARENT_SUB_CATEGORY_PRODUCT_FAILURE,
  payload,
});

